/**
 * @param {Processing} processing
 * @param {Creative} creative
 */
export default (processing, creative) => {
  creative.markAsProcessed();

  return Promise.resolve(creative);
}
